import actionTypes from 'SRC/modules/redux/actionTypes'

export const setRegions = (regions) => {
  return {
    type: actionTypes.SET_REGIONS,
    payload: regions
  }
}
